import ListVM from './list-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init: function(node) {
    var data = JSON.parse(node.dataset.reviewsData);

    const vm = new Vue(ListVM);
    vm.bindData(data);
    vm.$mount(node);

    // see https://github.com/jonlunsford/share.js for more options
    Kadenze.Share.init();
  }
};